import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import Form from './Form'
import style from './style.module.less'
@observer
export default class extends Component {
  render() {
    return (
      <div className={style.showCaseInfo}>
        <h3 className={style.viewBox}>
          <a onClick={() => hashHistory.push('/localMerchant/showCase')}>
            推荐橱窗
          </a>
          <em>/</em>编辑橱窗
        </h3>

        <Form {...this.props} />
      </div>
    )
  }
}
